export default () => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
  },
  {
    field: 'col-opt',
    title: '操作',
    headerAlign: 'center',
    align: 'left',
    fixed: 'left',
    width: 140,
    slots: {
      default: 'opt',
    },
  },
  {
    field: 'thermometerNo',
    fixed: 'left',
    minWidth: 200,
    title: '温度计编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'tempRange',
    fixed: 'left',
    minWidth: 200,
    title: '温度区间',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'calibrationValidity',
    fixed: 'left',
    minWidth: 200,
    title: '校准有效期',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'brandName',
    align: 'center',
    width: 140,
    title: '品牌',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'dispatchOrderNo',
    align: 'left',
    width: 200,
    title: '调度订单编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'coolerNo',
    align: 'left',
    width: 200,
    title: '冷藏箱编号',
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    align: 'center',
    width: 80,
    title: '状态',
    slots: { default: 'status' },
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createTime',
    title: '创建时间',
    width: 160,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'createByName',
    title: '创建人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyTime',
    title: '修改时间',
    width: 160,
    sortable: true,
    sortType: 'string',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: '修改人',
    width: 80,
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
